'use client';

import type { BoxProps } from '@mui/material/Box';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export function SignUpTerms({ sx, ...other }: BoxProps) {
  const { t } = useTranslate();

  return (
    <Box
      component="span"
      sx={[
        () => ({
          mt: 3,
          display: 'block',
          textAlign: 'center',
          typography: 'caption',
          color: 'text.secondary',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {`${t('auth.terms.agree')} `}
      <Link underline="always" color="text.primary">
        {t('auth.terms.tos')}
      </Link>
      {` ${t('auth.terms.and')} `}
      <Link underline="always" color="text.primary">
        {t('auth.terms.privacy')}
      </Link>
      .
    </Box>
  );
}
